import React from 'react';
import { Card, CardBody, Container, Row } from 'reactstrap';

import Breadcrumbs from '../../CommonElements/Breadcrumbs';
import CommonCardHeader from '../../Utils/CommonComponents/CommonCardHeader';
import { LoanRequestForm } from './Components/LoanRequestForm';
import { LoanRequestInfo } from './Components/LoanRequestInfo';

const LoanRequest = () => {
   return (
      <div className="page-body">
         <Breadcrumbs
            pageTitle="Solicitudes"
            parent="Sociedad"
            title="Solicitudes"
         />
         <Container fluid>
            <Card>
               <CommonCardHeader title="Solicitud de prestamo" />
               <CardBody>
                  <Row>
                     <LoanRequestForm />
                     <LoanRequestInfo />
                  </Row>
               </CardBody>
            </Card>
         </Container>
      </div>
   );
};

export default LoanRequest;
